import { PROJECT_ICONS, getProjectIconAsset } from '../../../data/projectIcons';
import { haptic } from '../../../utils/haptic';

const PICKER_STYLE: React.CSSProperties = {
  display: 'grid',
  gridTemplateColumns: 'repeat(5, 1fr)',
  gap: 8,
  maxHeight: 220,
  overflowY: 'auto',
  padding: 2,
};

export function EmojiPicker({
  value,
  onChange,
}: {
  value: string;
  onChange: (iconId: string) => void;
}) {
  return (
    <div style={PICKER_STYLE}>
      {PROJECT_ICONS.map((icon) => {
        const asset = getProjectIconAsset(icon.id);
        return (
          <button
            key={icon.id}
            type="button"
            title={icon.label}
            aria-pressed={value === icon.id}
            onClick={() => { haptic.select(); onChange(icon.id); }}
            style={{
              width: 44,
              height: 44,
              borderRadius: 12,
              border: value === icon.id
                ? `2px solid ${icon.color}`
                : '1px solid rgba(255,255,255,0.08)',
              background: value === icon.id ? icon.bg : 'rgba(255,255,255,0.03)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              cursor: 'pointer',
              transition: 'all 0.15s',
              padding: 8,
              boxShadow: value === icon.id ? `0 0 12px ${icon.color}40` : 'none',
            }}
          >
            <img
              src={asset.src}
              alt=""
              width={22}
              height={22}
              draggable={false}
              style={{ width: 22, height: 22, display: 'block', pointerEvents: 'none', userSelect: 'none' }}
            />
          </button>
        );
      })}
    </div>
  );
}
